import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { INutrientProcessingModel } from './nutrient-livestock-plan-processing.model';
import { INutrientLivestockPlanResults } from './nutrient-livestock-plan-results.model';

@Injectable()
export class NutrientLivestockPlanResultsService {
  constructor(private readonly apiService: ApiService) {}
  generateResults(
    nutrientProcessingModel: INutrientProcessingModel
  ): Promise<any> {
    return this.apiService.post(
      'v1/nutrient-processing',
      nutrientProcessingModel
    );
  }

  getLiveStockResults(
    planId: number
  ): Promise<INutrientLivestockPlanResults[]> {
    return this.apiService.get(
      `v1/nutrient-livestock-plan-results?nutrientLivestockPlanId=${planId}`
    );
  }

  deleteLiveStockResults(nutrientLivestockPlanId: number) {
    return this.apiService.delete(
      `v1/nutrient-livestock-plan-results?nutrientLivestockPlanId=${nutrientLivestockPlanId}`
    );
  }
}
